import { render, staticRenderFns } from "./arviointilomake-aloituskeskustelu-form.vue?vue&type=template&id=85174e06&scoped=true&"
import script from "./arviointilomake-aloituskeskustelu-form.vue?vue&type=script&lang=ts&"
export * from "./arviointilomake-aloituskeskustelu-form.vue?vue&type=script&lang=ts&"
import style0 from "./arviointilomake-aloituskeskustelu-form.vue?vue&type=style&index=0&id=85174e06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85174e06",
  null
  
)

export default component.exports